__turbopack_context__.v({
  "className": "gp03Uq_className",
});
